import type { IconProps } from './types'

export const FlagDeIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 64 48"
      className={className}
      aria-hidden="true"
    >
      <rect width="64" height="48" rx="8" fill="#FFCE00" />
      <path d="M0 0H64V32H0Z" fill="#DD0000" />
      <path d="M0 0H64V16H0Z" fill="#111111" />
    </svg>
  )
}
